module.exports = "<div class=\"unit-diagram tree-diagram\"></div>"


//////////////////
// WEBPACK FOOTER
// ./client/app/components/tree-diagram/tree-diagram.html
// module id = 902
// module chunks = 0